import React from "react";
import Modal from "../../../../shared/components/Modal/Modal";
import "./FreezePopupModal.css";

function FreezePopupModal({ isOpen, onClose, data }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeAboveModal
      stackClassName="freeze-popup-modal__dialog-stack"
      width="100%"
      height="auto"
      maxWidth="34rem"
      borderRadius="1.25rem"
      marginTop="0"
      closeButtonStyle={{
        width: "36px",
        height: "36px",
        padding: "0",
        fontSize: "14px",
      }}
    >
      <div className="freeze-modal">
        <div className="freeze-modal__icon-wrap">
          <img src={data?.icon_url} alt="" className="freeze-modal__icon" />
        </div>
        <h3 className="freeze-modal__title">{data?.title}</h3>
        <p className="freeze-modal__description">{data?.description}</p>
      </div>
    </Modal>
  );
}

export default FreezePopupModal;

